import { useTheme } from '@emotion/react'
import { ArrowForward } from '@mui/icons-material'
import { Paper, Stack, Typography } from '@mui/material'
import { RosterListProps } from 'client/pages/RosterSearches/ClientRosterCardPreview'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import useIsMobile from 'shared/hooks/useIsMobile'
import { formatAuditDate, getPxAsRem } from 'shared/utils'

const ClientMappingPreviewCard: FC<RosterListProps> = ({
    rosterName,
    rosterId,
    details,
    navigationTarget,
    isSelectable = true,
}) => {
    const theme = useTheme()
    const isDesktop = !useIsMobile()
    const navigate = useNavigate()
    return (
        <Stack
            component={Paper}
            borderRadius={getPxAsRem(3, 8)}
            direction="row"
            width="100%"
            display={'flex'}
            padding={isDesktop ? getPxAsRem(16, 24) : getPxAsRem(8)}
            minWidth={getPxAsRem(350)}
            spacing={3}
            justifyContent={'space-between'}
            sx={{ cursor: isSelectable ? 'pointer' : '' }}
            onClick={() => {
                if (isSelectable && navigationTarget) {
                    navigate(`${navigationTarget}/${rosterId}`)
                }
            }}
        >
            <Stack
                direction="row"
                gap={getPxAsRem(8)}
                sx={{
                    flexGrow: 1,
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
            >
                <Stack direction={'column'} gap={getPxAsRem(8)}>
                    <Typography variant={isDesktop ? 'h5' : 'h6'}>
                        {rosterName}
                    </Typography>
                    <Typography variant="subtitle1" color="textSecondary">
                        {formatAuditDate(
                            'Created',
                            details.createdBy,
                            details.createdAt
                        )}
                    </Typography>
                </Stack>

                {isSelectable && (
                    <ArrowForward
                        sx={{
                            fill: theme.palette.greyscale.grey_600,
                            margin: 'auto 0',
                        }}
                    />
                )}
            </Stack>
        </Stack>
    )
}

export default ClientMappingPreviewCard
